export const TEMPLATES = [
{
id: "job-offer-letter-template",
htmlTitle: "Job Offer Letter",
title: "Job Offer Letter Template",
breaks: [],
template:
`
[Company Name]
[Company Address]
[Date]

[Candidate First and Last Name]
[Candidate Address]
[City, State, Zip]

Dear [Candidate Name],

We are pleased to offer you the [full-time/part-time] position of [Job Title] at [Company Name], with an anticipated start date of [Start Date], contingent upon [Hiring Contingencies].

In this role, you will report to [Manager Name] at [Workplace Location]. Your primary responsibilities will include [Job Duties].

The starting salary for this position is [Dollar Amount] per [hour/year], paid [weekly/biweekly/monthly] via [direct deposit/check]. In addition, you will be eligible for [Additional Compensation].

As an employee of [Company Name], you will be eligible to participate in our benefits program, which includes [Benefits List].

Your employment with [Company Name] will be on an at-will basis, which means that either you or the company may terminate employment at any time, with or without cause or advance notice. This letter is not a contract of employment for any specific period.

Please confirm your acceptance of this offer by signing and returning this letter by [Offer Expiration Date].

We look forward to welcoming you to our team!

Sincerely,
[Your Name]
[Your Job Title]
[Company Name]

Candidate Signature: ___________________________
Candidate Printed Name: ________________________
Date: ___________________`
},

{
id: "us-employment-verification-letter",
htmlTitle: "Employment Verification Letter",
title: "Employment Verification Letter Template (USA)",
breaks: [],
template: `
[Company Name]
[Company Address]
[Company City, State, ZIP Code]
[Date]

[Recipient Name]
[Recipient Title]
[Organization Name]
[Address]
[Recipient City, State, ZIP Code]

RE: Employment Verification for [Employee Full Name]

Dear [Recipient Name/To Whom It May Concern],

This letter confirms that [Employee Full Name] is currently employed at [Company Name] in the capacity of [Job Title] within the [Department Name]. [He/She/They] has been employed with our organization since [Start Date] and remains actively employed as of the date of this letter.

Employment Details:
- Status: [Full-Time/Part-Time/Contract]
- Compensation: [Salary or Hourly Rate]
- Average Hours: [Hours Per Week]

This verification is provided at the request of [Employee Name] for the purpose of [Verification Purpose]. [Employee Name] has authorized the release of this information in accordance with the Fair Credit Reporting Act (FCRA) and applicable state laws.

Should you require additional verification, please contact the undersigned at [HR Phone Number] or [HR Email Address]. Do not disclose salary or other sensitive information without explicit written consent from the employee.

Sincerely,

[HR Representative Name]
[Job Title]
[Company Name]
[Contact Phone]
[Email Address]`
},

{
id: "us-employee-appreciation-letter",
htmlTitle: "Employee Appreciation Letter",
title: "Employee Appreciation Letter Template (USA)",
breaks: [],
template: `
[Company Name]
[Company Address]
[Company City, State, ZIP Code]
[Date]

[Employee Full Name]
[Employee Address]
[Employee City, State, ZIP Code]

Dear [Employee First Name],

I am pleased to take this opportunity to express my sincere appreciation for your outstanding work at [Company Name]. Your dedication and commitment to your role as [Job Title] have made a significant positive impact on our team.

We especially appreciate your contributions to [Contributions]. Your professionalism, positive attitude, and strong work ethic have not gone unnoticed.

Thank you for your continued hard work and for embodying the values of [Company Name]. We are grateful to have you as part of our organization and look forward to your continued success.

Sincerely,

[Your Name]
[Your Job Title]
[Company Name]
[Contact Information]`
},

{
id: "employee-appointment-letter",
htmlTitle: "Employee Appointment Letter",
title: "Employee Appointment Letter Template",
breaks: [],
template: `
[Company Name]
[Company Address]
[Company City, State, ZIP Code]
[Date]

[Employee Full Name]
[Employee Address]
[Employee City, State, ZIP Code]

Dear [Employee First Name],

We are pleased to formally appoint you as [Job Title] at [Company Name], effective [Start Date]. This letter outlines the terms of your employment:

1. Position & Responsibilities  
You will report to [Supervisors Name] and be responsible for [Job Responsibilities].

2. Compensation  
Your annual salary will be $[Salary], paid [biweekly/monthly]. This is a [exempt/nonexempt] position under the Fair Labor Standards Act (FLSA).

3. Benefits  
You are eligible for:
    - Health, dental, and vision insurance (effective after [Effective Days])
    - 401(k) plan with [401K Provider] company match
    - [Annual Days Off] days of paid time off annually

4. Work Schedule  
Your standard hours are [Standard Hours].

5. Contingencies  
This offer is contingent upon:
    - Satisfactory completion of a background check
    - Proof of eligibility to work in the U.S. (I-9 compliance)

6. At-Will Employment  
Your employment with [Company Name] is at-will, meaning either party may terminate the relationship at any time, with or without cause.

7. Confidentiality & Compliance  
You agree to adhere to all company policies, including confidentiality and intellectual property agreements.

Please sign and return this letter by [Expiration Date] to confirm acceptance.

Sincerely,  
[HR Manager Name]  
[Job Title]  
[Company Name]  
[Contact Information]
`
},

{
id: "termination-letter-template",
htmlTitle: "Termination Letter",
title: "Termination Letter Template",
breaks: [],
template: `
[Date]

[Employee Full Name]
[Employee Address]

Re: Termination of Employment

Dear [Employee First Name],

This letter serves as formal notice that your employment with [Company Name] will end effective [Termination Date].

Reason for Termination:
[Reason for Termination]

Final Compensation:
Your final paycheck, including [Paycheck Inclusions], will be issued by [Final Paycheck Date] via [Final Paycheck Method], per [Applicable State] law.

[Severance Details]

Benefits:
Health insurance coverage under COBRA will end on [Cobra End Date]. Enrollment information will be mailed separately.

Return of Company Property:
Please return the following items to [HR Contact] by [Return Date]:

    (  ) Laptop/equipment
    (  ) Access cards/keys
    (  ) Other items

Next Steps:
For questions, contact [HR Questions Contact] at [email/phone].

We thank you for your contributions and wish you success in your future endeavors.

Sincerely,
[HR Managers Name]
[Job Title]
[Company Name]

Employee Acknowledgment:
I confirm receipt of this termination letter.
Signature: _________________________
Date: _________________________`
},

{
id: "us-employee-resignation-acceptance-letter",
htmlTitle: "Employee Resignation Acceptance Letter",
title: "Employee Resignation Acceptance Letter Template (USA)",
breaks: [],
template: `
[Company Name]
[Company Address]
[Company City, State, ZIP Code]
[Date]

[Employee Full Name]
[Employee Address]
[Employee City, State, ZIP Code]

Dear [Employee First Name],

We acknowledge receipt of your resignation letter dated [Resignation Date] and accept your decision to resign from your position as [Job Title] at [Company Name]. Your last day of employment will be [Last Working Date].

Final Compensation:
Your final paycheck, including all wages and accrued paid time off, will be issued on [Payment Date] in accordance with [State] law. You will receive this via [direct deposit/mail] at the address on file.

Benefits Information:
Information regarding continuation of health insurance under COBRA and other applicable benefits will be mailed to you within 14 days of your separation date.

Return of Company Property:
Please return the following items to [HR Contact Name] by [Return Date]:

Laptop, charger, and peripherals

Access cards, keys, and ID badges

Company credit card

Transition Support:
To ensure a smooth handover, please coordinate with [Managers Name] to complete pending tasks and document critical processes. An exit interview may be scheduled upon request.

We appreciate your contributions to [Company Name] during your tenure and wish you success in your future endeavors.

Sincerely,

[Your Name]
[Your Job Title]
[Company Name]
[Contact Information]
`
},

{
id: "employment-status-change-template",
htmlTitle: "Employment Status Change Letter",
title: "Employment Status Change Letter Template",
breaks: [],
template: `
[Company Name]
[Company Address]
[Date]

[Employees Full Name]
[Employees Address]

Dear [Employees First Name],

This letter serves to confirm the details of your transition from [Current Title] to [New Title] at [Company Name], effective [Effective Date]. This change follows our discussion on [Discussion Date].

Reason for Change:  
[Reason for Change].

New Position Details:

- Job Title: [New Job Title]
- Department: [Department Name]
- Reporting To: [Supervisors Name and Title]
- Salary Adjustment: [New Salary] ([Effective Date])

Transition Support:  
We will offer [Training Resources] to assist you during this transition. A follow-up review will be conducted on [Review Date] to assess your progress.

Acknowledgment:  
Please sign and return this letter by [Expiration Date] to confirm receipt. Signing acknowledges notification, but not agreement with the decision.

Sincerely,  
[HR Managers Name]  
[HR Managers Title]  
[Company Name]

Employee Signature: _________________________  
Date: _________________________`
    },
{
id: "promotion-letter-template",
htmlTitle: "Promotion Letter",
title: "Promotion Letter Template",
breaks: [],
template: `
[Company Name]
[Company Address]
[City, State, ZIP Code]
[Date]

[Employee Full Name]
[Employee Address]
[City, State, ZIP Code]

Dear [Employee First Name]

We are pleased to promote you to the position of [New Job Title] effective [Effective Date]. This promotion recognizes your contributions to [Company Name] and confidence in your ability to excel in this new role.

Key Details of Your Promotion:
- Previous Position: [Current Job Title]
- New Position: [New Job Title]
- Department: [Department Name]
- Reporting To: [Manager Name]
- Previous Salary: [Previous Salary Amount]
- New Salary: [New Salary Amount]
- Effective Date: [Effective Date]

Your primary responsibilities will include:
[Key Responsibility 1]
[Key Responsibility 2]
[Key Responsibility 3]

This promotion does not alter the at-will nature of your employment. All other terms and conditions of your employment remain unchanged unless otherwise communicated in writing.

Please contact [HR Contact Name] at [Email/Phone] with any questions. We look forward to your continued success.

Sincerely

[HR Representative Name]
[Job Title]
[Company Name]
`
},
{
id: "salary-increase-letter-template",
htmlTitle: "Salary Increase Letter",
title: "Salary Increase Letter Template",
breaks: [],
template: `
[Company Name]
[Company Address]
[City, State, ZIP Code]
[Date]

[Employee Full Name]
[Employee Job Title]
[Department Name]

Dear [Employee First Name]

We are pleased to inform you that your salary will be increased in recognition of your valuable contributions to [Company Name].

Your current salary of [Current Salary Amount XX XXX annually XX XX hourly] will be increased to [Increased Salary Amount XX XXX annually XX XX hourly], effective [Date].

This adjustment reflects our appreciation for your work and our commitment to maintaining competitive compensation.

Your employment remains at-will, and all other terms and conditions of your employment remain unchanged unless otherwise communicated in writing.

Please sign and return this letter by [Date] to acknowledge receipt. If you have any questions, please contact [HR Contact Name] at [Email/Phone].

We appreciate your continued dedication to [Company Name].

Sincerely

[HR Representative Name]
[Job Title]
[Company Name]
`
},
{
id: "demotion-letter-template",
htmlTitle: "Demotion Letter",
title: "Demotion Letter Template",
breaks: [],
template: `
[Company Name]
[Company Address]
[City, State, ZIP Code]
[Date]

[Employee Full Name]
[Employee Job Title]
[Department Name]

Dear [Employee First Name]

This letter formally notifies you of a change to your employment status at [Company Name], effective [Effective Date].

Reason for Change:
[Brief factual explanation for demotion example Due to organizational restructuring Following performance review To better align skills with business needs]

New Position Details:
- Title: [New Job Title]
- Department: [Department Name]
- Reporting To: [Manager Name]
- Key Responsibilities:
[Responsibility 1]
[Responsibility 2]

Your new salary will be [New Salary Amount] effective [Effective Date].

This decision was made after careful consideration. We remain committed to supporting your success through:
- [Training/mentorship opportunities]
- [Regular performance check-ins]
- [Other support measures]

Your employment remains at-will. All other terms of your employment continue unchanged unless specified in writing.

Please sign and return this letter by [Date] to acknowledge receipt. Contact [HR Contact Name] at [Email/Phone] with questions.

Sincerely,

[HR Representative Name]
[Job Title]
[Company Name]
`
}, 
{
id: "employee-recommendation-letter",
htmlTitle: "Employee Recommendation Letter",
title: "Employee Recommendation Letter Template",
breaks: [],
template: `
[Company Name]
[Company Address]
[City State ZIP]
[Date]

[Recipient Name]
[Recipient Title]
[Organization Name]
[Organization Address]
[City State ZIP]

Dear [Recipient Name or To Whom It May Concern]

I am pleased to recommend [Employee Full Name] for [Position or Opportunity] at [Organization Name]. As [Your Job Title] at [Company Name], I worked directly with [Employee Full Name] from [Employee Start Date] to [Employee End Date] in the role of [Employee Job Title].

Throughout this time, [Employee Full Name] consistently demonstrated strengths in [Key Skill 1], [Key Skill 2], and [Key Skill 3]. [Employee Full Name] contributed positively to [Department or Project or Company], showing [Professional Trait 1] and [Professional Trait 2] in daily work.

[Employee Full Name] is known for [Brief Example of Positive Attribute or Contribution] and regularly supported colleagues and company goals. The approach to [Specific Aspect of Work] aligns well with [Organization Name Mission Statement or Values].

I am confident that [Employee Full Name] will excel in [Position or Opportunity] and bring value to your organization. This recommendation is given with my full endorsement.

For any further information, please contact me at [Your Phone Number] or [Your Email Address].

Sincerely

[Your Full Name]
[Your Job Title]
[Company Name]
[Your Contact Information]
`
},
{

    id: "employee-transfer-letter",
    htmlTitle: "Employee Transfer Letter",
    title: "Employee Transfer Letter Template",
    breaks: [],
    template: `
    [Your Name]
    HR Manager
    [Your Company Name]
    [Your Company Address]
    
    [Date]
    
    [Employee Name]
    [Employee Position]
    [Your Company Name]
    [Your Company Address]
    
    Dear [Employee Salutation and Last Name]
    
    We would like to express our deepest gratitude for the time and effort you have put into the [Current Department] team. Your dedication and hard work have significantly contributed to our success. However, we would like to inform you that your position will be transferred to the [New Department] starting from [Transfer Effective Date].
    
    We have full confidence that you will excel in this new position, just as you have in your past roles. Your [Skill one], [Skill two], and [Skill three] will be highly beneficial for the [New Department]. This transfer will give you an opportunity to build upon your skills and create an impact on a larger scale. You will be answering to the [New Reporting Manager], starting from the aforementioned date.
    
    Thank you for your continuous dedication to our company. We are excited to have you with the [New Department] and look forward to seeing the new heights you will take this department.
    
    Yours sincerely
    
    [Your Name]
    `
},
{
    id: "internship-offer-letter",
    htmlTitle: "Internship Offer Letter",
    title: "Internship Offer Letter Template",
    breaks: [],
    template: `
[Company letterhead]
[Company address]

[Offer date]

Dear [Candidate name],

Congratulations! I’m thrilled to extend an offer for our [Internship role title] internship in our [Department name] department at [Company name].

Your start date will be [Internship start date]. On your first day, you will report directly to [Manager or supervisor name and title] at [Workplace address]. Your internship will take place between the hours of [Working hours and days], with a cap at [Maximum weekly hours] per week.

We’re pleased to offer you a salary of [Salary amount] per [Pay period].

At [Company name], we pride ourselves on creating informative and rewarding experiences for our interns. That’s why you can look forward to receiving:
[List of internship benefits and perks]

To accept this offer, please sign and return this letter by [Offer expiration date]. In the meantime, feel free to reach out with any questions. We look forward to welcoming you to the team!

Sincerely,

[Sender signature]

[Sender printed name]
[Sender job title]

Candidate signature: ____________________________

Candidate printed name: _________________________

Date: ___________________
`

}, 
{

    id: "policy-change-notification-letter",
    htmlTitle: "Policy Change Notification Letter",
    title: "Policy Change Notification Letter Template",
    breaks: [],
    template: `
[Company name]
[Company address]

[Notification date]

[Recipient name]
[Recipient address]

Dear [Recipient salutation],

We wish to announce some changes that have been made to our company policies, effective from [Policy effective date]. The changes are listed below:

[Policy change details]

We hope that all the changes shall be adhered to by every employee, and everyone will help make the new system successful. We apologize for any inconvenience.

Thank you for your continued support.

Sincerely,

[Sender name]
[Sender designation]
`
}, 
{
    id: "travel-policy",
    htmlTitle: "Travel Policy",
    title: "Travel Policy Template",
    breaks: [],
    template: `
[Company name]
[Company address]

[Policy issue date]

Travel Policy

Table of Contents

1. Purpose  
2. Scope  
3. Definitions  
4. Policy details  
    - Travel authorization process and timelines  
    - Booking procedures and vendor guidelines  
    - Accommodation standards and limitations  
    - Expense coverage and reimbursement  
    - Safety and insurance requirements  
5. Procedures  
6. Compliance  
7. Policy review  

1. Purpose

The purpose of this [Company name] travel policy is to outline the guidelines and provisions for managing business-related travel. This policy ensures that all travel arrangements are made consistently, cost-effectively, and within organizational expectations, while also addressing safety and insurance requirements for employees.

2. Scope

This policy applies to all employees of [Company name] who are required to travel domestically and internationally for business purposes.

3. Definitions

Authorized traveler: An employee who has received approval from their supervisor or the designated approver to travel for business purposes.

Business days: Standard working days (Monday through Friday) excluding public holidays.

4. Policy details

Travel authorization process and timelines

- Request submission: Employees must submit a travel request form to their direct supervisor or the travel coordinator at least [Minimum advance days for travel request] before the planned departure date.
- Approval: Travel must be approved by [Approval authority], followed by confirmation from [Finance or budget authority] to ensure budget allocation.
- Urgent travel: In cases of urgent travel, the submission period may be waived, with immediate effect, pending post-travel approval.

Booking procedures and vendor guidelines

- Vendor selection: Travel bookings must be made through [Approved travel agency or platform] unless otherwise justified and approved by [Travel coordinator].
- Booking time frame: All travel bookings should be completed at least [Minimum advance days for booking] prior to departure to secure optimal rates.
- Flight and transportation: Travelers are to book [Class of travel for domestic] for all domestic travel and [Class of travel for international] for international flights exceeding [Flight duration threshold].

Accommodation standards and limitations

- Standard of accommodation: Employees are authorized to book [Accommodation standard] hotels.
- Booking: Accommodation should be arranged through [Approved travel agency or platform] and within the vicinity of the business engagement to minimize transport time and costs.
- Limitations: The company does not cover expenses for [List of non-reimbursable accommodation expenses].

Expense coverage and reimbursement

- Eligibility: Expenses eligible for reimbursement include [List of reimbursable expenses].
- Submission: All expense claims must be submitted within [Expense claim submission period] of travel completion along with required receipts and documentation.
- Reimbursement: Reimbursements will be processed within [Reimbursement processing period] upon submission and approval of complete and accurate expense reports.

Safety and insurance requirements

- Travel insurance: The company provides travel insurance for all employees traveling on business, which includes [Coverage details].
- Safety guidelines: Travelers must adhere to all safety instructions and guidelines and are required to complete a safety briefing prior to international travel.

5. Procedures

Steps to submit travel requests and expense claims are available on [Company intranet or resource location].

Emergency contact numbers and insurance details are provided to travelers prior to departure.

6. Compliance

Failure to comply with this policy may result in disciplinary action up to and including termination of employment. Expense claims that do not comply with the outlined policy may be rejected.

7. Policy review

This policy shall be reviewed [Policy review frequency] or as needed to ensure its effectiveness and relevance to [Company name] operations.

By adhering to the guidelines set forth in this travel policy, [Company name] aims to ensure a safe, cost-effective, and compliant approach to business travel.
`
}, 
{
id: "sexual-harassment-policy",
    htmlTitle: "Sexual Harassment Policy",
    title: "Sexual Harassment Policy Template",
    breaks: [],
    template: `
[Company name]
[Company address]

[Policy issue date]

Sexual Harassment Policy

1. Purpose  
The purpose of this policy is to ensure a workplace free from sexual harassment, where all employees feel safe and respected. This policy outlines [Company name]'s commitment to creating a professional environment that actively discourages any form of sexual harassment and provides clear guidelines for action.

2. Scope  
This policy applies to all employees of [Company name], including contractors, clients, and suppliers, during work hours, company events, or work-related communications (digital or offsite).

3. Definitions  
Sexual harassment includes unwelcome sexual advances, requests for favors, or verbal/physical conduct of a sexual nature when:  
- Submission affects employment terms or decisions.  
- Conduct interferes with work performance or creates a hostile environment.

4. Prohibited Conduct  
Prohibited behaviors include but are not limited to:  
- Unwelcome sexual advances or physical conduct.  
- Offering employment benefits for sexual favors.  
- Threats, retaliation, or derogatory comments/jokes.  
- Displaying sexually suggestive materials.  

5. Reporting Procedures  
Employees may report incidents to [Human Resources contact] or via [Company reporting tool]. Complaints are treated urgently and confidentially.

6. Investigation Process  
- Preliminary review by [Designated authority].  
- Formal investigation (if warranted) with interviews and evidence review.  
- Both parties notified of findings.

7. Confidentiality  
Confidentiality is maintained to the greatest extent possible during investigations.

8. Protection Against Retaliation  
Retaliation against reporters or participants is strictly prohibited.

9. Disciplinary Actions  
Actions may include warnings, training, suspension, or termination, depending on severity.

10. Policy Review  
This policy is reviewed [Review frequency] to align with legal and organizational needs.
`
}, 
{
    id: "sexual-harassment-policy",
    htmlTitle: "Sexual Harassment Policy",
    title: "Sexual Harassment Policy Template",
    breaks: [],
    template: `
[Company name]
[Company address]

[Policy issue date]

Sexual Harassment Policy

1. Purpose  
The purpose of this policy is to ensure a workplace free from sexual harassment, where all employees feel safe and respected. This policy outlines [Company name]'s commitment to creating a professional environment that actively discourages any form of sexual harassment and provides clear guidelines for action.

2. Scope  
This policy applies to all employees of [Company name], including contractors, clients, and suppliers, during work hours, company events, or work-related communications (digital or offsite).

3. Definitions  
Sexual harassment includes unwelcome sexual advances, requests for favors, or verbal/physical conduct of a sexual nature when:  
- Submission affects employment terms or decisions.  
- Conduct interferes with work performance or creates a hostile environment.

4. Prohibited Conduct  
Prohibited behaviors include but are not limited to:  
- Unwelcome sexual advances or physical conduct.  
- Offering employment benefits for sexual favors.  
- Threats, retaliation, or derogatory comments/jokes.  
- Displaying sexually suggestive materials.  

5. Reporting Procedures  
Employees may report incidents to [Human Resources contact] or via [Company reporting tool]. Complaints are treated urgently and confidentially.

6. Investigation Process  
- Preliminary review by [Designated authority].  
- Formal investigation (if warranted) with interviews and evidence review.  
- Both parties notified of findings.

7. Confidentiality  
Confidentiality is maintained to the greatest extent possible during investigations.

8. Protection Against Retaliation  
Retaliation against reporters or participants is strictly prohibited.

9. Disciplinary Actions  
Actions may include warnings, training, suspension, or termination, depending on severity.

10. Policy Review  
This policy is reviewed [Review frequency] to align with legal and organizational needs.
`
},
{
        id: "pto-policy",
    htmlTitle: "Paid Time Off Policy Template",
    title: "Paid Time Off Policy Template",
    breaks: [],
    template: `
[Company name] Paid Time Off Policy

Effective Date: [Policy effective date]
Policy Owner: [Policy owner department]
Applies To: [Employee coverage scope]

1. Purpose and Scope

This Paid Time Off (PTO) policy establishes a comprehensive framework for managing employees' time away from work while maintaining operational effectiveness. This policy promotes work-life balance and employee well-being by providing paid leave that can be used for vacation, illness, personal matters, or other approved purposes. All regular full-time and part-time employees are covered under this policy, with specific provisions outlined below.

2. Eligibility Requirements

Employment Status: All regular full-time employees working [Minimum hours for full time] or more hours per week and part-time employees working [Minimum hours for part time] or more hours per week are eligible for PTO benefits. Temporary employees, contractors, interns, and probationary employees during their initial [Probationary period length] of employment are not eligible for PTO accrual.

Eligibility Commencement: Employees become eligible for PTO benefits on [Eligibility start date]. PTO accrual begins immediately upon eligibility, and employees may use accrued PTO after completing [Waiting period for PTO usage] of eligible employment.

3. PTO Accrual Rates

PTO accrues based on the employee's length of service and employment status according to the following schedule:

Full-Time Employees:
Years [Service years tier one]: [Accrual rate tier one] ([Annual hours tier one] annually)
Years [Service years tier two]: [Accrual rate tier two] ([Annual hours tier two] annually)
Years [Service years tier three]: [Accrual rate tier three] ([Annual hours tier three] annually)

Part-Time Employees:
Years [Part time service years tier one]: [Part time accrual rate tier one] ([Part time annual hours tier one] annually)
Years [Part time service years tier two]: [Part time accrual rate tier two] ([Part time annual hours tier two] annually)
Years [Part time service years tier three]: [Part time accrual rate tier three] ([Part time annual hours tier three] annually)

Executive Team:
Years [Executive service years tier one]: [Executive accrual rate tier one] ([Executive annual hours tier one] annually)
Years [Executive service years tier two]: [Executive accrual rate tier two] ([Executive annual hours tier two] annually)

4. PTO Usage Guidelines

Minimum Usage Increments: PTO must be requested and used in minimum increments of [Minimum PTO increment]. Employees may not use PTO in fractional hour amounts below this threshold.

Advance Notice Requirements: Planned PTO requires advance approval through designated management channels. Employees should submit requests at least [Advance notice period] in advance for extended absences of [Extended absence threshold] or more consecutive days. Emergency PTO requests must be submitted at the earliest reasonable opportunity.

Request Approval Criteria: PTO requests are evaluated based on departmental staffing needs, employee seniority, length of requested absence, elapsed time since the employee's last extended vacation, and any applicable blackout periods. Management reserves the right to limit the number of employees taking PTO simultaneously to maintain operational requirements.

5. PTO Carryover and Maximum Accrual

Annual Carryover Limits: Employees may carry over up to [Maximum carryover hours] of unused PTO from one calendar year to the next. Any PTO exceeding this limit will be forfeited unless prohibited by applicable state law. Carried-over PTO must be used within the first [Carryover usage deadline] of the following calendar year.

Maximum Accrual Cap: PTO accrual will cease when an employee's balance reaches [Maximum accrual multiplier] times their annual PTO entitlement. Accrual will resume once the balance falls below this threshold through PTO usage.

6. PTO Payout on Separation

Termination Payout: In states requiring PTO payout upon separation, employees will receive compensation for all accrued and unused PTO at their current rate of pay. In states without payout requirements, PTO payout follows [Company payout policy].

Calculation Method: PTO payouts are calculated based on the employee's regular hourly rate or salary equivalent at the time of separation, excluding overtime premiums, bonuses, or other variable compensation.

7. Holiday Interaction

When a company-observed holiday falls during an employee's PTO period, the holiday will not be deducted from the employee's PTO balance. Employees must coordinate with their supervisor to adjust their PTO request accordingly.

8. Coordination with Other Leaves

This PTO policy operates independently of other leave entitlements, including [List of other leave types]. Employees may not use PTO to extend legally mandated unpaid leaves unless specifically approved by [Leave approval authority].

9. Record Keeping and Administration

The [Record keeping department] maintains all PTO records, including accrual calculations, usage tracking, and balance reporting. Employees can access their current PTO balances through [PTO tracking system] or by contacting [PTO contact department] directly.

10. Policy Modifications

[Company name] reserves the right to modify this PTO policy with appropriate notice to employees. Changes will be communicated through [Communication channels] and updated in the employee handbook. Employees will be bound by policy modifications unless prohibited by applicable law or existing employment agreements.
`
},
{
    id: "administrative-assistant-job-description",
    htmlTitle: "Administrative Assistant Job Description",
    title: "Administrative Assistant Job Description Template",
    breaks: [],
    template: `
Job Title: [Job title]

About Our Company:

At [Company name], we're committed to [Company mission or values]. We work with a team of talented, motivated individuals who share our passion for [Company focus areas]. As a forward-thinking company, we prioritize [Company culture priorities], making [Company name] a place where you can truly thrive.

Location: [Work location and arrangement]

Hours: [Work schedule and hours]

Job Description:

Join us as [Job title], where you'll play an essential role in supporting our team and ensuring smooth operations across various departments. This is an exciting opportunity for a detail-oriented individual who thrives in a collaborative environment and is eager to make a meaningful impact. We'd love to hear from you if you're organized, proactive, and ready to grow with us.

Job Responsibilities and Tasks:

- Report to [Reporting manager] for daily updates, accomplishments, and any issues requiring attention.
- Manage daily administrative tasks, including [Primary administrative duties].
- Coordinate [Meeting and event coordination responsibilities] and prepare agendas.
- Assist in project management by [Project management duties].
- Handle [Financial and accounting responsibilities].
- Liaise with [External stakeholder responsibilities], providing excellent customer service.
- Maintain [Office management responsibilities] and manage inventory.

Required Skills and Qualifications:

- [Experience requirement] as an administrative assistant or similar role.
- Proficiency in [Required software and tools].
- Excellent [Key soft skills required].
- Strong [Communication and interpersonal requirements].
- Ability to [Work style and collaboration requirements].
- [Education requirement]; [Preferred education level] preferred.

Salary: [Salary range] annually, based on experience and qualifications.

Company Benefits:

- [Health and insurance benefits]
- [Time off benefits]
- [Retirement benefits]
- [Professional development benefits]
- [Additional employee benefits]

Application Information:

Ready to join our team? Then apply now by submitting your application, including your resume and a cover letter by [Application deadline]. Candidates selected for consideration will be contacted for an initial interview, followed by a second interview if applicable. Interviews will take place [Interview timeline]. For follow-up, please contact our [Contact department] at [Contact email] or [Contact phone number]. We look forward to receiving your application.
`
}, 
{
        id: "warehouse-associate-job-description",
    htmlTitle: "Warehouse Associate Job Description",
    title: "Warehouse Associate Job Description Template",
    breaks: [],
    template: `
[Company name]
[Company address]
[Company website]

Job Title: [Job title]
Department: [Department name]
Employment Type: [Employment type]
Location: [Facility location]
Shift: [Work shift and schedule]
Salary Range: [Salary range]

About [Company name]:

At [Company name], we are committed to delivering excellence in [Company focus area] and customer satisfaction. As a trusted leader in the [Industry or sector], we value [Company core values]. Our warehouse associates play a vital role in ensuring timely, accurate, and seamless operations that keep our business moving forward.

Be part of a dynamic, supportive team and advance your career in a fast-paced, rewarding environment. Apply today and make your mark at [Company name], where your contributions are valued, and your success is our priority. We are an equal opportunity employer and welcome applications from all qualified candidates.

Position Summary:

We are seeking a reliable and detail-oriented Warehouse Associate to join our warehouse operations team. The successful candidate will be responsible for receiving, processing, storing, and shipping inventory while maintaining accurate records and ensuring workplace safety. This role offers opportunities for skill development and career advancement within our operations team.

Essential Duties and Responsibilities:

Receiving and Processing:
- Receive, unload, and inspect incoming shipments for accuracy and damage
- Verify shipment contents against purchase orders and delivery receipts
- Process and label incoming inventory using [Inventory management system]
- Report discrepancies and damages to [Reporting manager title]

Inventory Management:
- Organize and store products in designated warehouse locations
- Maintain accurate inventory records using [Warehouse management system]
- Conduct regular cycle counts and physical inventory audits
- Monitor stock levels and report low inventory to supervisors
- Ensure proper rotation of products following [Inventory rotation method]

Order Fulfillment:
- Pick, pack, and prepare customer orders for shipment
- Verify order accuracy against customer invoices and packing lists
- Package products safely and efficiently using appropriate materials
- Coordinate with shipping carriers for timely dispatch
- Process returns and exchanges according to company procedures

Equipment Operation and Safety:
- Operate warehouse equipment including [Equipment types]
- Perform daily equipment inspections and report maintenance needs
- Follow all safety protocols and wear required personal protective equipment
- Maintain clean and organized work areas
- Participate in safety training programs and meetings

Required Qualifications:

Education and Experience:
- High school diploma or equivalent required
- [Minimum experience requirement] in warehouse or logistics environment
- [Preferred certifications or additional experience]

Technical Skills:
- Experience with warehouse management systems and inventory software
- Proficiency with [Specific software or systems used]
- Ability to operate [Required equipment list]
- [Equipment certifications required] certification required
- Basic computer skills and data entry abilities

Core Competencies:
- Strong attention to detail and accuracy
- Excellent organizational and time management skills
- Ability to work efficiently in fast-paced environment
- Team collaboration and communication skills
- Problem-solving abilities
- Commitment to safety and quality standards
- Reliability and punctuality

Physical Requirements:

- Ability to lift, carry, push, and pull up to [Weight limit] pounds regularly
- Ability to stand, walk, and bend for extended periods
- Manual dexterity for handling products and operating equipment
- Visual acuity for reading labels, screens, and documentation
- Ability to work in varying temperatures and warehouse conditions
- Capability to climb ladders and work at heights when necessary

Working Conditions:

This position operates in a warehouse environment with exposure to [Environmental conditions]. Work involves [Shift details] with occasional overtime during peak periods. Safety equipment and training are provided.

Compensation and Benefits:

Salary: [Salary range] per hour, based on experience
Benefits Package:
- [Health insurance details]
- [Dental and vision coverage]
- [Retirement plan details]
- [Paid time off policy]
- [Safety incentive programs]
- [Employee discount programs]
- [Training and advancement opportunities]

Career Development:

We offer opportunities for advancement including:
- [Equipment operator certifications]
- [Leadership development programs]
- [Cross-training opportunities]
- [Tuition reimbursement programs]

Safety Commitment:

[Company name] is committed to maintaining a safe workplace. All employees are expected to follow safety protocols, report hazards immediately, and participate in ongoing safety training programs.

Equal Employment Opportunity:

[Company name] is an equal opportunity employer committed to workplace diversity. We do not discriminate based on race, color, religion, gender, sexual orientation, gender identity, national origin, age, disability, veteran status, or any other protected characteristic.

Application Process:

To apply, please submit:
- Completed application form
- Current resume
- [Required certifications or licenses]
- [Reference requirements]

Apply online at: [Application website]
Or submit materials to: [Application email]
Application Deadline: [Application deadline]

For questions about this position, contact [Contact person] at [Contact information].

[Company name] reserves the right to modify this job description at any time. This description is not intended to be an exhaustive list of all duties and responsibilities.
`
}, 
{
    id: "cna-job-description",
    htmlTitle: "CNA Job Description",
    title: "CNA Job Description Template",
    breaks: [],
    template: `
[Facility name]
[Facility address]
[Facility website]

Job Title: [Job title]
Department: [Department name]
Employment Type: [Employment type]
Location: [Facility location]
Shift: [Work shift and schedule]
Salary Range: [Salary range]

About [Facility name]:

At [Facility name], we are committed to delivering compassionate, high-quality healthcare services to our patients and residents. As a trusted leader in [Healthcare specialty or setting], we value [Facility core values] and foster a supportive environment where healthcare professionals can thrive. Our CNAs play a vital role in providing exceptional patient care and making a meaningful difference in the lives of those we serve.

Join our dedicated healthcare team where your compassion and skills are valued, and your professional growth is our priority. We offer comprehensive benefits, ongoing education opportunities, and a collaborative work environment that supports both your career development and work-life balance.

Position Summary:

We are seeking a compassionate and skilled Certified Nursing Assistant to join our [Department name] team. The successful candidate will provide direct patient care under the supervision of licensed nursing staff, assist patients with activities of daily living, and contribute to maintaining a safe, therapeutic environment. This role offers opportunities for professional growth and specialization within our healthcare facility.

Essential Duties and Responsibilities:

Direct Patient Care:
- Provide compassionate and competent patient care under the supervision of [Supervising staff]
- Assist patients with activities of daily living including [Specific ADL activities]
- Help patients with mobility, transfers, and positioning to prevent complications
- Ensure patient comfort, dignity, and safety at all times
- Respond promptly to patient calls and requests for assistance

Clinical Support:
- Monitor and record vital signs including [Vital signs to be monitored]
- Observe and report changes in patient condition to [Reporting authority]
- Assist with [Medical procedures or treatments] as directed by nursing staff
- Maintain accurate documentation using [Documentation system]
- Follow infection control protocols and safety procedures

Nutritional and Dietary Support:
- Assist patients with meals and ensure adequate nutrition and hydration
- Monitor and record [Intake and output requirements]
- Follow dietary restrictions and accommodate patient preferences
- Report dietary concerns or changes in appetite to nursing staff

Equipment and Environment:
- Maintain clean and organized patient care areas
- Properly use and maintain [Medical equipment types]
- Follow proper procedures for [Equipment maintenance tasks]
- Ensure patient rooms meet safety and comfort standards

Required Qualifications:

Education and Certification:
- High school diploma or equivalent required
- Successful completion of state-approved CNA training program
- Current [State name] Certified Nursing Assistant certification
- Current [CPR certification type] certification
- [Additional certifications required]

Experience:
- [Minimum experience requirement] in healthcare or patient care setting preferred
- Experience with [Specific patient populations] preferred
- [Specialized experience requirements]

Core Competencies:
- Excellent communication and interpersonal skills
- Strong attention to detail and observational abilities
- Ability to work effectively in fast-paced healthcare environment
- Compassionate and patient-centered approach to care
- Physical stamina and emotional resilience
- Team collaboration and professional demeanor
- Basic computer skills for documentation and communication

Physical Requirements:

- Ability to lift, carry, push, and pull up to [Weight limit] pounds
- Ability to stand, walk, and bend for extended periods
- Manual dexterity for patient care tasks and equipment operation
- Visual and auditory acuity for patient monitoring and communication
- Ability to work in various healthcare environments
- Capability to respond quickly in emergency situations

Working Conditions:

This position operates in a healthcare facility environment with exposure to [Environmental conditions]. Work involves [Shift details] including weekends and holidays. Personal protective equipment is provided and required when indicated.

Professional Development:

We support our CNAs with:
- [Continuing education opportunities]
- [Specialty certification support]
- [Career advancement pathways]
- [Mentorship programs]
- [Tuition reimbursement programs]

Quality and Safety Commitment:

[Facility name] is committed to maintaining the highest standards of patient care and safety. All CNAs are expected to follow evidence-based practices, participate in quality improvement initiatives, and maintain professional standards of practice.

Equal Employment Opportunity:

[Facility name] is an equal opportunity employer committed to workplace diversity and inclusion. We do not discriminate based on race, color, religion, gender, sexual orientation, gender identity, national origin, age, disability, veteran status, or any other protected characteristic.

Application Process:

To apply, please submit:
- Completed application form
- Current resume
- Copy of current CNA certification
- Copy of CPR certification
- [Reference requirements]
- [Background check requirements]

Apply online at: [Application website]
Or submit materials to: [Application email]
Application Deadline: [Application deadline]

For questions about this position, contact [Contact person] at [Contact information].

[Facility name] reserves the right to modify this job description at any time. This description is not intended to be an exhaustive list of all duties and responsibilities.
`
}, 
{
        id: "office-administrator-job-description",
    htmlTitle: "Office Administrator Job Description",
    title: "Office Administrator Job Description Template",
    breaks: [],
    template: `
Job Brief

We are looking for a reliable Office Administrator. They will undertake administrative tasks, ensuring the rest of the staff has adequate support to work efficiently.

The tasks of the office administrator will include bookkeeping and mentoring office assistants. The ideal candidate will be competent in prioritizing and working with little supervision. They will be self-motivated and trustworthy.

The office administrator ensures smooth running of [Company name] offices and contributes in driving sustainable growth.

Responsibilities

- Coordinate office activities and operations to secure efficiency and compliance to [Company name] policies
- Supervise administrative staff and divide responsibilities to ensure performance
- Manage agendas, travel arrangements, and appointments for [Upper management]
- Manage phone calls and correspondence including [Communication types]
- Support budgeting and bookkeeping procedures
- Create and update records and databases with [Data types]
- Track stocks of office supplies and place orders when necessary
- Submit timely reports and prepare presentations and proposals as assigned
- Assist colleagues whenever necessary

Requirements and Skills

- Proven experience as an office administrator, office assistant or relevant role
- Outstanding communication and interpersonal abilities
- Excellent organizational and leadership skills
- Familiarity with office management procedures and basic accounting principles
- Excellent knowledge of [Required software] and office management software
- Qualifications in secretarial studies will be an advantage
- [Education requirement]; [Preferred education] in office administration or relevant field is preferred
`
    },
    {
  id: "affirmative-action-plan-template",
  htmlTitle: "Affirmative Action Plan Template for Workplace Diversity and Compliance",
  title: "Affirmative Action Plan Template",
  breaks: [],
  template: `
[Company Name]
[Company Address]
[City, State ZIP]
Plan Dates: [Start Date] – [End Date]
Prepared By: [Name]
Contact: [Email/Phone]

Affirmative Action Plan

1. Purpose:
This Affirmative Action Plan (AAP) outlines the actions and strategies [Company Name] will take to ensure equal employment opportunities for all individuals, particularly members of underrepresented groups.

2. Company Info:
- Legal Name: [Name]
- HQ Location: [Location]
- Employees: [Number]
- Industry: [Industry]

3. Workforce Analysis:
Provide a list of each job group with total employees and counts for male, female, minorities, veterans, and individuals with disabilities.
- Job Group: [Group Name]
- Total: [Number]
- Male: [Number]
- Female: [Number]
- Minority: [Number]
- Veteran: [Number]
- Disabled: [Number]

4. Availability Analysis:
- Area: [Region]
- Data Source: [Source]
- Estimates: [Details]

5. Placement Goals:
- Job Group: [Job Group]
- Groups: [Underutilised Group]
- Goal: [Goal]
- Target Date: [Date]

6. Action Programs:
Recruitment:
[List Initiatives]

Training:
[List Initiatives]

Outreach:
[List Activities]

7. Audit & Reporting:
- Responsible: [Name]
- Frequency: [Interval]
- Methods: [Methods]

8. Authorisation:
This Affirmative Action Plan has been reviewed and approved by the undersigned.

Signature: _____________________________
Name: [Approver Name]
Title: [Title]
Date: [Date]
`
},
{
  id: "performance-appraisal-template",
  htmlTitle: "Performance Appraisal Template for Fair, Consistent Reviews",
  title: "Performance Appraisal Template",
  breaks: [],
  template: `
Performance Appraisal

1. Employee Info:
Employee Name: [Name]
Job Title: [Title]
Department: [Department]
Manager: [Manager Name]
Review Period: [MM/YY–MM/YY]

2. Performance Summary:
Overall Summary: [Summary]

3. Key Responsibilities:
[Duties and goals]

4. Competency Ratings:
(Scale 1–5: 1=Needs Improvement, 5=Excellent)
Job Knowledge: [Rating]
Quality of Work: [Rating]
Productivity: [Rating]
Teamwork: [Rating]
Communication: [Rating]
Problem-Solving: [Rating]

5. Strengths:
[Top strengths]

6. Areas to Improve:
[Key improvements]

7. Next-Period Goals:
[SMART goals]

8. Employee Comments:
[Employee notes]

9. Manager Comments:
[Manager notes]

10. Sign-Off:
Employee Signature: __________________  Date: __________
Manager Signature: __________________   Date: __________
`
},
{
  id: "social-media-policy-template",
  htmlTitle: "Social Media Policy Template for Employee Conduct Online",
  title: "Social Media Policy Template",
  breaks: [],
  template: `
[Company Name]
[Date]

Social Media Policy

This policy governs employee use of social media platforms, both personal and professional, and aims to safeguard [Company Name]'s reputation while empowering responsible participation online.

Purpose:
To establish clear, consistent rules around how employees represent themselves and [Company Name] on social media.

Applies To:
All employees, contractors, interns, and temporary staff using social media platforms, whether during work hours or outside of them.

General Guidelines:
- Do not post confidential or proprietary information related to [Company Name], clients, partners, or employees.
- Always communicate respectfully and professionally when referencing the company or coworkers.
- Clearly state that personal opinions are your own. Recommended disclaimer: "Opinions expressed are my own and do not reflect those of [Company Name]."
- Never speak on behalf of [Company Name] unless explicitly authorised.
- Refrain from responding to media or public inquiries. Redirect them to [Designated Contact or Team].
- Do not use the company's logo, branding elements, or copyrighted material without prior written approval.
- Avoid engaging in arguments or public debates that may reflect poorly on the company.
- Report any online content or interactions that may pose reputational risk to [HR Contact Name] at [HR Contact Email].

Platform-Specific Guidelines:

LinkedIn:
- Use LinkedIn professionally to reflect your role and expertise.
- Refrain from posting confidential business strategies or internal discussions.
- Company-related updates should only be shared through official channels or with permission.

Instagram:
- Avoid sharing images of the workplace or coworkers without consent.
- Do not tag [Company Name] in personal posts that could damage the brand's image.
- Use stories or reels responsibly—what seems temporary can still be screenshotted or recorded.

Twitter (X):
- Exercise caution when engaging in real-time discussions or trending topics.
- Avoid sarcasm, political commentary, or polarising opinions that may be misinterpreted.
- Never share company performance, upcoming launches, or internal events.

YouTube:
- Do not create or upload videos featuring company premises, branding, or confidential content.
- Vlogs, behind-the-scenes content, or tutorials involving company tools must be pre-approved.

Pinterest:
- Avoid pinning or sharing internal creative assets unless they're cleared for public use.
- Any visual content tagged with [Company Name] must follow brand guidelines.

TikTok:
- Do not use the company's name, logo, or coworkers in TikTok without written consent.
- Refrain from participating in viral trends that may contradict company values or brand tone.

Content Review and Disciplinary Action:
All social media activity that may impact the company is subject to review. Violations of this policy can result in disciplinary action, including warnings, suspension, or termination.

Questions or Concerns:
If you're unsure whether a post or activity is appropriate, contact [HR Contact Name] at [HR Contact Email].

Signed,
[Policy Owner Name]
[Policy Owner Title]
`
},
{
    id: "ai-policy-template",
    htmlTitle: "AI Policy Template for Responsible Use of Artificial Intelligence",
    title: "AI Policy Template",
    breaks: [],
    template: `
[Company Name]  
[Department]  
[Date]  

Artificial Intelligence (AI) Usage Policy  

Overview:  
This policy defines the responsible and ethical use of artificial intelligence (AI) technologies within [Company Name], in line with applicable US laws and industry best practices. It ensures transparency, accountability, and fairness in how AI is adopted, governed, and monitored.  

Purpose:  
To provide clear guidance on the acceptable development, deployment, and use of AI systems by employees, contractors, and vendors, ensuring responsible practices and risk mitigation.  

Scope:  
This policy applies to all personnel (including employees, contractors, and third-party vendors) who interact with or build AI-driven tools and systems on behalf of [Company Name].  

Definitions:  
- Artificial Intelligence (AI): [AI definition]  
- High-Risk AI: [High-risk criteria]  

Acceptable Use:  
- [Approved AI tools]  
- [Allowed use cases]  
- [Generative AI limits]  

Unacceptable Use:  
- Use of AI to generate false, discriminatory, or misleading content  
- Unauthorized processing of personally identifiable information (PII)  
- Deployment of unvetted AI tools that may compromise security or compliance  

Data Privacy and Security:  
- All AI systems must comply with [Applicable laws]  
- Use of AI tools that handle personal data must follow internal data retention and access protocols  
- AI-generated content must be logged and auditable  

Employee Responsibilities:  
- Disclose use of third-party AI tools to [Compliance Officer]  
- Participate in required AI training  
- Report misuse or risks  

Oversight & Governance:  
- The AI Governance Committee at [Company Name] will oversee policy enforcement  
- Audits and periodic risk assessments will be conducted semi-annually  
- All new AI deployments must be pre-approved by the committee  

Training & Awareness:  
- Required training: Responsible AI, Bias Detection, and Privacy Basics  
- Training is mandatory before access to AI tools is granted  

Policy Review:  
- This policy will be reviewed every 6–12 months or when new rules or tools are introduced  

Distribution:  
- This policy is available on [Company Portal]  
- Synced with Winslow for live Q&A  

Contact:  
For questions, contact [Policy Owner] at [Email Address]  

Signed,  
[Policy Owner]  
[Job Title]  
[Last Review Date]  
`
  },
  {
    id: "contract-termination-template",
    htmlTitle: "Contract Termination Template for Employees, Contractors, and Vendors",
    title: "Contract Termination Template",
    breaks: [],
    template: `
[Company Name]  
[Company Address]  
[City, State, ZIP]  
[Date]  

[Recipient Name]  
[Recipient Address]  
[City, State, ZIP]  

Subject: Contract Termination Notice  

Dear [Recipient Name],  

This letter serves as official notice of termination of the [Employment/Contractor/Vendor] agreement dated [Contract Date] between [Company Name] and [Recipient Name]. The contract will end effective [Termination Date].  

Reason for Termination:  
[State Reason Clearly] 

Final Settlement and Obligations:  
1. Final payment will be processed by [Final Payment Date].  
2. Any unpaid invoices must be submitted by [Invoice Deadline].  
3. Company property, including [List Property], must be returned by [Return Date].  
4. Access to company systems, facilities, and accounts will be revoked by [Access End Date].  

Legal and Compliance:  
This contract termination template ensures compliance with U.S. labor and contract laws. Please refer to [Policy Name] or [Contract Clause] for further details regarding termination provisions.  

Next Steps:  
- For employees: HR will confirm final paycheck, benefits, and COBRA (if applicable).  
- For contractors/vendors: Please complete outstanding obligations and ensure smooth transfer of ongoing projects.    

If you have any questions, contact [HR Contact] at [HR Email] or [Phone Number].  

We appreciate your contributions and wish you the best in future endeavors.  

Sincerely,  
[Manager Name]  
[Manager Title]  
[Company Name]  
`
  },
  {
    id: "income-verification-template",
    htmlTitle: "Income Verification Template for Employees",
    title: "Income Verification Template",
    breaks: [],
    template: `
[Company Name]  
[Company Address]  
[City, State, ZIP]  
[Date]  

[Recipient Name]  
[Recipient Address]  
[City, State, ZIP]  

Subject: Income Verification Letter  

Dear [Recipient Name],  

This letter confirms the employment and income details of [Employee Name], who is currently employed with [Company Name].  

Employment Details:  
1. Employee Name: [Employee Name]  
2. Job Title: [Job Title]  
3. Employment Type: [Full-Time/Part-Time]  
4. Start Date: [Start Date]  
5. Current Status: [Active/Inactive]  

Income Details:  
1. Base Salary: [Base Salary] per [Year/Month/Week]  
2. Additional Compensation: [Bonuses/Commission] (if applicable)  
3. Total Annual Income: [Total Income]  

This verification is provided upon request of [Employee Name] for the purpose of [Loan/Lease/Verification].  

If further information is required, please contact [HR Contact] at [HR Email] or [Phone Number].  

Sincerely,  
[HR Manager Name]  
[HR Manager Title]  
[Company Name]  
`
  },
  {
    id: "welcome-letter-template",
    htmlTitle: "Welcome Letter Template for Employees and Contractors",
    title: "Welcome Letter Template",
    breaks: [],
    template: `
[Company Name]  
[Company Address]  
[City, State, ZIP]  
[Date]  

[Recipient Name]  
[Recipient Address]  
[City, State, ZIP]  

Subject: Welcome to [Company Name]  

Dear [Recipient Name],  

Welcome to [Company Name]! We are excited to have you join us as a [Job Title/Role], starting on [Start Date]. Your skills and experience will play an important role in helping us achieve our goals, and we are eager to see your contributions.  

To help you get started smoothly, here's what you can expect:  

1. **First Day Details**  
   - Start Time: [Start Time]  
   - Location/Access: [Office Location] or [Remote Setup]  
   - Point of Contact: [Manager Name]  

2. **Onboarding Schedule**  
   - Orientation: [Orientation Date]  
   - Team Introduction: [Team Meeting]  
   - Systems Setup: [System Setup Date]  

3. **Resources Provided**  
   - Welcome Kit: [Welcome Kit]  
   - Policy Guide: [Policy Guide]  
   - Benefits Overview: [Benefits Guide]  

4. **Expectations & Support**  
   - Key Goals: [Initial Goals]  
   - HR Contact: [HR Email] / [HR Phone]  
   - Direct Manager: [Manager Email]  

Please complete your onboarding forms by [Form Deadline]. These will ensure you have access to payroll, benefits, and required tools from your first day.    

Once again, welcome aboard—we're glad to have you with us!  

Sincerely,  
[HR Representative]  
[HR Title]  
[Company Name]  
`
  },
  {
    id: "warning-letter-template",
    htmlTitle: "Warning Letter Template for Employees and Contractors",
    title: "Warning Letter Template",
    breaks: [],
    template: `
[Company Name]  
[Company Address]  
[City, State, ZIP]  
[Date]  

[Recipient Name]  
[Recipient Address]  
[City, State, ZIP]  

Subject: Official Warning Notice  

Dear [Recipient Name],  

This letter serves as an official warning regarding [Issue/Behavior] observed on [Date of Incident]. This conduct violates [Policy/Agreement] and must be corrected immediately.  

Details of Concern:  
1. Incident Description: [Describe Incident]  
2. Impact on Team/Work: [Impact Details]  
3. Prior Warnings (if any): [Previous Warnings]  

Required Corrective Actions:  
- [Action 1] by [Deadline]  
- [Action 2] by [Deadline]  
- [Action 3] by [Deadline]  

Failure to correct this behavior may result in further disciplinary action, up to and including termination of employment/contract in accordance with [Policy Name].  

HR will provide guidance and support to help you meet these expectations. For any clarification, contact [HR Email] or [HR Phone].  

Sincerely,  
[HR Representative]  
[HR Title]  
[Company Name]  
`
  },
  {
    id: "hybrid-work-policy-template",
    htmlTitle: "Hybrid Work Policy Template for Employees and Contractors",
    title: "Hybrid Work Policy Template",
    breaks: [],
    template: `
[Company Name]  
[Company Address]  
[City, State, ZIP]  
[Date]  

Subject: Hybrid Work Policy  

Dear [Recipient Name],  

This document outlines [Company Name]'s Hybrid Work Policy for employees and contractors. The policy aims to provide flexibility while maintaining productivity, collaboration, and compliance with company standards.  

**Eligibility**  
- Employees/Contractors eligible: [Eligible Roles]  
- Minimum tenure: [Tenure Requirement]  
- Approval process: [Approval Steps]  

**Work Schedule**  
- Remote Days: [Number of Days] per week  
- Onsite Days: [Number of Days] per week  
- Core Hours: [Start Time] – [End Time]  
- Flex Hours: [Flexibility Details]  

**Expectations**  
- Availability during core hours: [Yes/No]  
- Communication tools: [Tools List]  
- Attendance reporting: [Reporting Process]  
- Task tracking: [Task Management Tool]  

**Equipment & Resources**  
- Provided by company: [Equipment List]  
- Employee responsibility: [Home Setup Guidelines]  
- IT Support: [IT Contact Info]  

**Security & Compliance**  
- Data protection: [Policy/Guidelines]  
- Confidential information: [Handling Instructions]  
- VPN and secure access: [Requirements]  

**Review & Adjustments**  
- Policy review frequency: [Frequency]  
- Feedback mechanism: [Feedback Process]  
- Amendments communicated via: [Communication Channel]  

For questions or clarification, please contact HR at [HR Email] or [HR Phone].  

Sincerely,  
[HR Representative]  
[HR Title]  
[Company Name]  
`
  },
  {
    id: "letter-of-reprimand-template",
    htmlTitle: "Letter of Reprimand Template for Employee Misconduct",
    title: "Letter of Reprimand Template",
    breaks: [],
    template: `
[Company Name]  
[Company Address]  
[City, State ZIP]  
[Date]  

Subject: Letter of Reprimand  

Dear [Employee Name],  

This letter serves as a formal reprimand regarding [incident/behavior] that occurred on [Date]. After review, it has been determined that this conduct violates [Policy Name] of [Company Name]'s policies.  

**Incident Description**  
On [Date], it was observed/reported that you [Misconduct Summary]. This behavior does not align with our standards of [Standard Type].  

**Policy Reference**  
The above conduct is in violation of [Policy Section].  

**Impact**  
Such actions negatively affect [Impact Area].  

**Expectations for Improvement**  
Moving forward, you are expected to:  
- [Expectation One]  
- [Expectation Two]  
- [Expectation Three]  

Failure to show immediate and sustained improvement may result in further disciplinary action, up to and including termination of employment.  

**Acknowledgment**  
Please sign below to acknowledge receipt of this letter. Your signature does not indicate agreement but confirms that the matter has been discussed.  

Employee Signature: ________________________ Date: ___________  
Manager Signature: _________________________ Date: ___________  

If you have questions, please contact [HR Contact] at [HR Email] or [HR Phone].  

Sincerely,  
[Manager Name]  
[Job Title]  
[Company Name]  
`
  },
  {
    id: "direct-deposit-form",
    htmlTitle: "Direct Deposit Form Template",
    title: "Direct Deposit Form",
    breaks: [],
    template: `
DIRECT DEPOSIT FORM

EMPLOYEE INFORMATION
Full Name: [Employee Name]  
Employee ID: [Employee ID]  
Social Security Number (last 4 digits): [SSN Last 4 Digits]  
Address: [Employee Address]  
City, State, ZIP: [City, State, ZIP]  
Phone/Email: [Phone or Email]  

BANK INFORMATION
Bank Name: [Bank Name]  
Bank Address: [Bank Address]  
Routing Number: [Routing Number]  
Account Number: [Account Number]  
Account Type: [Checking or Savings]  

DEPOSIT INSTRUCTIONS
Primary Account Deposit Amount or Percentage: [Primary Deposit Amount/Percentage]  
Secondary Account Deposit Amount or Percentage (if applicable): [Secondary Deposit Amount/Percentage]  
Additional Account Details (if applicable): [Additional Account Details]  

AUTHORIZATION
I authorize [Company Name] to deposit my payroll directly into the account(s) listed above. This authorization will remain in effect until I provide written notice to change or cancel it. I understand it is my responsibility to ensure my bank details are correct, and I may be asked to provide a voided check or bank verification letter.  

Employee Signature: [Employee Signature]  
Date: [Date Submitted]  

HR/PAYROLL USE ONLY
Verified By: [HR Representative Name]  
Date Processed: [Date Processed]  
Notes: [HR Notes]  
`
  },
  {
    id: "time-off-request-form",
    htmlTitle: "Time Off Request Form Template",
    title: "Time Off Request Form",
    breaks: [],
    template: `
TIME OFF REQUEST FORM

EMPLOYEE INFORMATION
Employee Name: [Employee Name]  
Employee ID (if applicable): [Employee ID]  
Department: [Department]  
Manager/Supervisor: [Manager/Supervisor]  

REQUEST DETAILS
Type of Leave: [Leave Type]  
Start Date: [Start Date]  
End Date: [End Date]  
Total Days Requested: [Total Days Requested]  

Reason for Leave (optional): [Reason for Leave]  

Contact Information During Leave (optional): [Phone/Email]  

Employee Signature: [Employee Signature]  
Date Submitted: [Date Submitted]  

MANAGER/SUPERVISOR REVIEW
Status (Approved/Denied): [Approval Status]  
Comments/Notes: [Manager Comments]  
Manager/Supervisor Signature: [Manager Signature]  
Date: [Manager Review Date]  

HR USE ONLY
Recorded in System: [Recorded Status]  
HR Representative: [HR Representative Name]  
Date Processed: [Date Processed]  
`
  },
  {
    id: "exit-interview-form",
    htmlTitle: "Exit Interview Form Template",
    title: "Exit Interview Form",
    breaks: [],
    template: `
EXIT INTERVIEW FORM

EMPLOYEE INFORMATION
Full Name: [Employee Name]
Employee ID: [Employee ID]
Department: [Department]
Job Title: [Job Title]
Manager/Supervisor: [Manager Name]
Date of Hire: [Date of Hire]
Last Working Day: [Last Working Day]

REASON FOR LEAVING
Primary Reason for Leaving: [Primary Reason]
Secondary Factors (if any): [Secondary Factors]
If another opportunity, what attracted you to it: [Attraction Factors]

WORK EXPERIENCE RATINGS (1 = Poor, 5 = Excellent)
Job satisfaction: [1–5]
Relationship with manager: [1–5]
Relationship with team: [1–5]
Opportunities for growth: [1–5]
Recognition and feedback: [1–5]
Training and development: [1–5]
Work-life balance: [1–5]
Compensation and benefits: [1–5]

OPEN-ENDED FEEDBACK
What did you like most about working here: [Response]
What did you like least about working here: [Response]
What would you improve about the company culture: [Response]
Were your job responsibilities clear and realistic: [Response]
Did you have the tools and resources needed to perform effectively: [Response]
How could we improve support for employee growth and career development: [Response]

COMPANY AND POLICY FEEDBACK
Overall company communication rating (1–5): [1–5]
Were company policies clear and accessible: [Response]
Did you feel the company supported diversity, equity, and inclusion: [Response]
Would you recommend this company as a place to work (Yes/No and Why): [Response]

FINAL SECTION
Do you plan to stay connected with the company alumni network (Yes/No): [Response]
Would you consider rejoining in the future if the right role were available (Yes/No): [Response]
Any final comments or advice for leadership: [Response]

Employee Signature: [Employee Signature]
Date: [Date]

HR/Interviewer Name: [HR Representative]
Date of Interview: [Interview Date]
`
  },
  {
    id: "vacation-request-form",
    htmlTitle: "Vacation Request Form Template",
    title: "Vacation Request Form",
    breaks: [],
    template: `
VACATION REQUEST FORM

EMPLOYEE INFORMATION
Employee Name: [Employee Name]
Employee ID (if applicable): [Employee ID]
Department: [Department]
Manager/Supervisor: [Manager/Supervisor]

VACATION DETAILS
Vacation Start Date: [Vacation Start Date]
Vacation End Date: [Vacation End Date]
Total Vacation Days Requested: [Total Vacation Days Requested]

ACCRUED VACATION BALANCE
Vacation Days Accrued: [Vacation Days Accrued]
Vacation Days Already Taken: [Vacation Days Already Taken]
Vacation Days Remaining After This Request: [Vacation Days Remaining]

Reason for Vacation (optional): [Reason for Vacation]

Contact Information During Vacation (optional): [Phone/Email]

Employee Signature: [Employee Signature]
Date Submitted: [Date Submitted]

MANAGER/SUPERVISOR REVIEW
Approval Status: [Approval Status]
Manager Comments: [Manager Comments]
Manager/Supervisor Signature: [Manager Signature]
Date: [Manager Review Date]

HR USE ONLY
Updated in HRIS: [HRIS Update Status]
HR Representative: [HR Representative Name]
Date Processed: [Date Processed]
`
  }
];